module.exports = __webpack_public_path__ + "static/media/empty-state.9f6e17ee.png";